<template>
  <collapsible>
    <sub-menu
      v-if="isOpen"
      id="primary-submenu"
      class="primary-menu-submenu"
      :current-url="currentUrl"
      :items="subMenu.children"
      :aria-labelledby="labelledBy"
      @itemSelected="item => $emit('itemSelected', item)"
    />
  </collapsible>
</template>

<script>
import Collapsible from '../Shared/Collapsible';
import SubMenu from './SubMenu';

export default {
  components: {
    Collapsible,
    SubMenu
  },
  props: {
    subMenu: {
      type: Object,
      default: () => ({})
    },
    currentUrl: {
      type: String,
      default: null
    },
    primaryMenuActiveItem: {
      type: String,
      default: null
    },
    primaryMenuOpen: {
      type: Boolean,
      default: true
    },
    labelledBy: {
      type: String,
      default: ''
    }
  },
  computed: {
    isOpen() {
      return (
        this.primaryMenuActiveItem === this.subMenu.name && this.primaryMenuOpen
      );
    }
  }
};
</script>
